import request from 'utils/request';
import {PostAddress} from './types/PostAddress';
import {CustomPostAddress} from './types/CustomPostAddress';

export const getPostAddress = (address: string): Promise<PostAddress[]> => {
    return request(`/post-address/getAddresses`, {params: {address}}).then((res) => res.data as PostAddress[]);
};

export const savePostAddress = (data: CustomPostAddress): Promise<CustomPostAddress> => {
    return request('/new-address-registry', {data, method: 'POST'}).then(
        (res) => res.data as CustomPostAddress
    );
};
